import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from 'react-redux';
import { createCustomer, getCustomerDetail } from "../../slices/customers";
import { convertErrorsFromServer } from "../../utils";

const DeliveryAddressForm = ({ onChange }) => {

    const {
        register,
        handleSubmit,
        reset,
        watch,
        setValue,
        setError,
        getValues,
        formState: { errors }
    } = useForm({
        defaultValues: {
            delivery_name: "",
            address_1: "",
            address_2: "",
            address_3: "",
            city: "",
            zip_code: "",
        }
    });

    const watchAllFields = watch();

    useEffect(() => {
        const subscription = watch((value, { name, type }) =>
            onChange(getValues())
        )
        return () => subscription.unsubscribe()
    }, [watchAllFields])

    return (
        <>
            <div className="row">
                <div className="col-12 mb-4">
                    <label>{gettext('Delivery name')}</label>
                    <input type="text" {...register("name")} className={`form-control ${errors.name && "is-invalid"}`} />
                </div>
            </div>
            <div className="row">
                <div className="col-md-6 col-12 mb-4">
                    <label>{gettext('Address')}</label>
                    <input type="text" {...register("address_1")} className={`form-control ${errors.addressaddress_1 && "is-invalid"}`} />
                </div>
                <div className="col-md-2 col-4 mb-4">
                    <label>{gettext('Zip code')}</label>
                    <input type="text" {...register("zip_code")} className={`form-control ${errors.addresszip_code && "is-invalid"}`} />
                </div>
                <div className="col-md-4 col-8 mb-4">
                    <label>{gettext('City')}</label>
                    <input type="text" {...register("city")} className={`form-control ${errors.addresscity && "is-invalid"}`} />
                </div>
                <div className="col-6 mb-4">
                    <label>{gettext('Address 2')}</label>
                    <input type="text" {...register("address_2")} className={`form-control ${errors.addressaddress_2 && "is-invalid"}`} />
                </div>
                <div className="col-6 mb-4">
                    <label>{gettext('Address 3')}</label>
                    <input type="text" {...register("address_3")} className={`form-control ${errors.addressaddress_3 && "is-invalid"}`} />
                </div>
            </div>
        </>
    )
}

export default DeliveryAddressForm